import { render, staticRenderFns } from "./Editar-Ocorrencia.vue?vue&type=template&id=7837ddbc&"
import script from "./Editar-Ocorrencia.vue?vue&type=script&lang=js&"
export * from "./Editar-Ocorrencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editar-Ocorrencia.vue"
export default component.exports